import React, { useState, useEffect } from 'react'
import { FiMapPin } from "react-icons/fi"
import LocationSelectionModal from './LocationSelectionModal';


const MobileLocationSelector: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [selectedLocation, setSelectedLocation] = useState<{
        state: string;
        city: string | null;
    }>({
        state: "Sélectionner une région",
        city: null
    });

    // Listen for location selection events
    useEffect(() => {
        const handleLocationSelect = (event: CustomEvent) => {
            const { stateName, cityName } = event.detail;
            setSelectedLocation({
                state: stateName || "Sélectionner une région",
                city: cityName || null
            });
        };

        window.addEventListener('locationSelected', handleLocationSelect as EventListener);
        return () => {
            window.removeEventListener('locationSelected', handleLocationSelect as EventListener);
        };
    }, []); return (
        <>
            {/* Map Button */}
            <button
                onClick={() => setIsModalOpen(true)}
                className="flex items-center gap-2 bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white font-medium py-2 px-4 rounded-lg transition-all border border-white/30"
            >
                <FiMapPin className="text-lg" />
                <span className="text-sm">
                    {selectedLocation.city
                        ? `${selectedLocation.city}, ${selectedLocation.state}`
                        : "Choisir une région"}
                </span>
            </button>

            {/* Location Selection Modal */}
            <LocationSelectionModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    )
}

export default MobileLocationSelector